module.exports = __webpack_public_path__ + "static/media/yqgl.2c4696eb.webm";